import { useSelector } from "react-redux";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import { XAxis } from "./XAxis";
import { currencyFormatter } from "../../../../services";
import { RevenueChanges } from "./RevenueChanges";
import { UNREALIZED_COLORS } from "../../constants";
import { Button } from "../../../../components/base/Button";
import { UnrealizedBarChart } from "../../../../components/charts/UnrealizedBarChart";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3.5)}px ${theme.spacing(3)}px`,
  },
}));

export const PortfolioPowerRevenueCharges = ({
  currentChartData,
  estimationChartData,
  currentAddingPowerRevenues,
  currentReducingUnrealizedRevenues,
  estimationAddingPowerRevenues,
  estimationReducingUnrealizedRevenues,
}) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Grid className={classes.box} item xs={12} sm={8}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Power Revenues Changes</Typography>
        <Button text="APPROVE NEW Power ASSETS" />
      </Grid>

      <Grid container spacing={4} id="portfolio-power-revenues-changes">
        {currentChartData.length ? (
          <Grid item xs={12} sm={6}>
            <RevenueChanges
              year="1Y"
              values={[
                currencyFormatter(currentReducingUnrealizedRevenues, currencySymbol),
                currencyFormatter(currentAddingPowerRevenues, currencySymbol),
              ]}
            />
            <UnrealizedBarChart
              chartData={currentChartData}
              colors={UNREALIZED_COLORS}
              barSize={20}
              bottom={-10}
            />
            <XAxis
              labels={[
                "Today’s unrealized power assets revenues",
                "Revised unrealized power assets revenues",
                "New power revenues",
              ]}
            />
          </Grid>
        ) : null}
        {estimationChartData.length ? (
          <Grid item xs={12} sm={6}>
            <RevenueChanges
              year="20Y"
              values={[
                currencyFormatter(estimationReducingUnrealizedRevenues, currencySymbol),
                currencyFormatter(estimationAddingPowerRevenues, currencySymbol),
              ]}
            />
            <UnrealizedBarChart
              chartData={estimationChartData}
              colors={UNREALIZED_COLORS}
              barSize={20}
              bottom={-10}
            />
            <XAxis
              labels={[
                "Current est. 20Y power assets revenues",
                "Revised 20Y power assets revenues",
                "Revised 20Y power revenues",
              ]}
            />
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
